import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {chatdeskUpdatesActions} from "_actions";
import {buildGetCompanyUpdatePayload, shouldViewCompanyUpdate} from "../../utilities/CompanyUpdateUtils";

export default function(organizationId) {
    const dispatch = useDispatch();

    useEffect(() => {
        getActiveCompanyUpdate();
    }, [organizationId]);

    const getActiveCompanyUpdate = () => {
        if(organizationId) {
            const payload = buildGetCompanyUpdatePayload(organizationId);
            if(!payload) return;
            dispatch(chatdeskUpdatesActions.getAll(payload));
        }
    }

    const companyUpdateObj = useSelector(state => state.chatdeskUpdates.updatesList);
    const loadingCompanyUpdates = useSelector(state => state.chatdeskUpdates.loading);
    let shouldView = false;
    let companyUpdate = {};

    if(!loadingCompanyUpdates && !_.isEmpty(companyUpdateObj)) {
        const {selectedUpdate, shouldViewUpdate} = shouldViewCompanyUpdate(companyUpdateObj);
        companyUpdate = selectedUpdate;
        shouldView = shouldViewUpdate;
    }
    return { companyUpdate, loadingCompanyUpdates, shouldView };
}